import { useEffect, useState } from 'react';
import { requestPresignedDownload } from '../../api/files';
import { tWorkspace } from '../../lib/workspace-i18n';

/**
 * 이미지 미리보기 (2026-08-14).
 *
 * 목록의 파일 대부분이 채팅 첨부고 그중 상당수가 이미지인데, 워크스페이스에서는 열 수 없어
 * "다운로드해 확인" 뿐이었다. 렌더러가 필요 없는 유일한 형식이라 `<img>` 하나로 끝난다.
 *
 * ⚠ 바이트 캐시(`fetchFileBytesShared`)를 쓰지 않는다. 편집기가 쓰는 그 캐시는 문서를
 *   ArrayBuffer 로 들고 있는데, 이미지는 보기만 하면 되므로 원본을 메모리에 통째로 올릴
 *   이유가 없다. presigned URL 을 `<img>` 에 그대로 물리면 브라우저가 알아서 스트리밍한다.
 * ⚠ presigned URL 은 5분짜리다. 다 받은 뒤 만료되는 것은 무해하지만(이미 그려졌다),
 *   패널을 오래 열어 둔 뒤 새로고침되면 다시 발급받아야 하므로 파일이 바뀌면 재발급한다.
 */
export function WorkspaceImagePreview({ fileId, name }: { fileId: string; name: string }) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setUrl(null);
    setError(null);
    void (async () => {
      try {
        const res = await requestPresignedDownload(fileId, { purpose: 'preview' }); // 미리보기 = 「열람」(§3.4.1)
        if (!cancelled) setUrl(res.downloadUrl);
      } catch (err) {
        if (!cancelled) setError((err as Error)?.message ?? 'error');
      }
    })();
    return () => { cancelled = true; };
  }, [fileId]);

  if (error) return <div className="workspace-docpanel-status" role="status">{error}</div>;
  if (url === null) {
    return (
      <div className="workspace-docpanel-status" role="status">
        {tWorkspace('workspace.grid.loading')}
      </div>
    );
  }
  return (
    <div className="workspace-docpanel-imagewrap">
      <img
        className="workspace-docpanel-image"
        src={url}
        alt={name}
        onError={() => setError(tWorkspace('workspace.editor.image_failed'))}
      />
    </div>
  );
}
